module.exports = __webpack_public_path__ + "media/homeProperty/PropertyImge01-ae2a913e.jpg";